/**
 * i18n English translation file
 */

import aside from './aside.json';
import bitable from './bitable.json';
import capacity from './capacity.json';
import captcha from './captcha.json';
import caption from './caption.json';
import chart from './chart.json';
import common from './common.json';
import debug from './debug.json';
import components from './components.json';
import constModule from './const.json';
import coupon from './coupon.json';
import deleteModule from './delete.json';
import delete_bar from './delete_bar.json';
import directory from './directory.json';
import editor from './editor.json';
import file_preview from './file_preview.json';
import global from './global.json';
import hooks from './hooks.json';
import mind_map from './mind_map.json';
import mindmap from './mindmap.json';
import moveTo from './moveTo.json';
import order from './order.json';
import page_feeds from './page_feeds.json';
import pay from './pay.json';
import pay_access from './pay_access.json';
import payment from './payment.json';
import rebate from './rebate.json';
import search from './search.json';
import serviceCenter from './service_center.json';
import share from './share.json';
import space from './space.json';
import stats from './stats.json';
import time from './time.json';
import upgrade from './upgrade.json';
import utils from './utils.json';
import views from './views.json';
import pkg_common from './pkg_common.json';

export default {
  ...aside,
  ...bitable,
  ...capacity,
  ...captcha,
  ...caption,
  ...chart,
  ...common,
  ...debug,
  ...components,
  ...constModule,
  ...coupon,
  ...deleteModule,
  ...delete_bar,
  ...directory,
  ...editor,
  ...file_preview,
  ...global,
  ...hooks,
  ...mind_map,
  ...mindmap,
  ...moveTo,
  ...order,
  ...page_feeds,
  ...pay,
  ...pay_access,
  ...payment,
  ...rebate,
  ...search,
  ...serviceCenter,
  ...share,
  ...space,
  ...stats,
  ...time,
  ...upgrade,
  ...utils,
  ...views,
  ...pkg_common,
};
